<!-- =========================================================================================
  File Name: TeacherView.vue
  Description: Teacher View page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="page-teacher-view">

    <vs-alert color="danger" title="Teacher Not Found" :active.sync="teacher_not_found">
      <span>Teacher record with teacherID: {{ this.teacherID }} not found. </span>
      <span>
        <span>Check </span><router-link :to="{name:'teacher-list'}" class="text-inherit underline">All Teachers</router-link>
      </span>
    </vs-alert>

    <vx-card v-if="teacher_data">

      <div slot="no-body" class="tabs-container px-6 pt-6">

        <vs-tabs v-model="activeTab" class="tab-action-btn-fill-conatiner">
          <vs-tab label="개인정보">
            <div class="tab-text">
              <teacher-view-tab-information class="mt-4" :data="teacher_data" />
            </div>
          </vs-tab>
          <vs-tab label="">
            <div class="tab-text">
              <teacher-view-tab-class class="mt-4" :data="teacher_data" />
            </div>
          </vs-tab>
          <vs-tab label="">
            <div class="tab-text">
              <teacher-view-tab-study class="mt-4" :data="teacher_data" />
            </div>
          </vs-tab>
        </vs-tabs>

      </div>

    </vx-card>
  </div>
</template>

<script>
import TeacherViewTabInformation from './TeacherViewTabInformation.vue'
import TeacherViewTabClass from './TeacherViewTabClass.vue'
import TeacherViewTabStudy from './TeacherViewTabStudy.vue'

import { fetchData } from '@/api/module'

export default {
  components: {
    TeacherViewTabInformation,
    TeacherViewTabClass,
    TeacherViewTabStudy
  },
  data () {
    return {
      teacherID: this.$route.params.teacherID,
      teacher_data: null,
      teacher_not_found: false,
      activeTab: 0
    }
  },
  watch: {
    activeTab () {
      this.fetch_teacher_data(this.teacherID)
    }
  },
  methods: {
    async fetch_teacher_data () {
      try {
        const { data } = await fetchData(`teacher/${this.teacherID}`)
        this.teacher_data = data.data
        console.log(data)

      } catch (error) {

        this.$vs.notify({
          title: 'Error',
          text: error.response.data.msg,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        }) 
      }
    }
  },
  created () {
    this.fetch_teacher_data()   
  }
}

</script>

<style lang="scss">
#avatar-col {
  width: 10rem;
}

#page-teacher-view {
  table {
    td {
      vertical-align: top;
      min-width: 140px;
      padding-bottom: .8rem;
      word-break: break-all;
    }

    &:not(.permissions-table) {
      td {
        @media screen and (max-width:370px) {
          display: block;
        }
      }
    }
  }
}


@media screen and (min-width:1201px) and (max-width:1211px),
only screen and (min-width:636px) and (max-width:991px) {
  #account-info-col-1 {
    width: calc(100% - 12rem) !important;
  }

}

</style>
